const ptnNum = new RegExp('\\d+$')
const ptnTel = new RegExp('^[\\d]{10,11}$')
const ptnStr = new RegExp('^\\w+$')
const ptnMail = new RegExp('^[a-zA-Z0-9.\\+\\-_]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$')
const ptnPostCd = new RegExp('^\\d{7}$')
const ptnAddress = new RegExp('[^\\d-+~@/a-z]$')
const ptnKana = new RegExp('^[ァ-ヶー　]+$')
// 半角英字、全角英字、数字をそれぞれ1種類以上含む8文字以上60文字以下の値
const ptnPassword = new RegExp('^(?=.*?[a-z])(?=.*?\\d)[!-~]{8,20}$')
const ptnDate = new RegExp('^\\d{4}-\\d{1,2}-\\d{1,2}$')

// 数値チェック
export const isNumber = (val) => {
  let l = ptnNum.test(val)
  return l
}
// 電話番号チェック
export const isTel = (val) => {
  let l = ptnTel.test(val)
  return l
}
/** 文字列チェック */
export const isStr = (val) => {
  let l = ptnStr.test(val)
  return l
}
/** メールアドレスチェック */
export const isMail = (val) => {
  let l = ptnMail.test(val)
  return l
}
/** 郵便番号チェック */
export const isPostCd = (val) => {
  let l = ptnPostCd.test(val)
  return l
}
/** 住所チェック（半角禁止） */
export const isAddress = (val) => {
  let l = ptnAddress.test(val)
  return l
}
/** カナ文字チェック */
export const isKana = (val) => {
  let l = ptnKana.test(val)
  return l
}
/** パスワードチェック */
export const isPassword = (val) => {
  let l = ptnPassword.test(val)
  return l
}
/** 日付チェック */
export const isDate = (val) => {
  let l = ptnDate.test(val)
  return l
}

/** null or undefined チェック */
export const isNullOrUndefined = (val) => {
  return (val === undefined || val === null)
}

/* IE 判定 */
export const isBrawserIE = function () {
  let agent = window.navigator.userAgent.toLowerCase()
  console.log('agent: ' + agent)
  if (agent.indexOf('msie') === -1 && agent.indexOf('trident') === -1) {
    return false
  }
  return true
}

// ブラウザチェック
export const brawserCheck = function () {
  if (browsercase() === 'iphone' || browsercase() === 'ipad' ||
      browsercase() === 'safari' || browsercase() === 'edge' || browsercase() === 'chrome') {
    return true
  }
  return false
}

// ブラウザチェック
export const brawserCheckForDaros = function () {
  if (browsercase() === 'chrome') {
    return true
  }
  return false
}

export const browsercase = function () {
  let userAgent = window.navigator.userAgent.toLowerCase()
  let ret = ''
  if (userAgent.indexOf('iphone') !== -1) {
    ret = 'iphone'
  } else if (userAgent.indexOf('ipad') !== -1) {
    ret = 'ipad'
  } else if (userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1) {
    ret = 'ie'
  } else if (userAgent.indexOf('edge') !== -1) {
    ret = 'edge'
  } else if (userAgent.indexOf('chrome') !== -1) {
    ret = 'chrome'
  } else if (userAgent.indexOf('safari') !== -1) {
    ret = 'safari'
  } else if (userAgent.indexOf('firefox') !== -1) {
    ret = 'firefox'
  } else if (userAgent.indexOf('opera') !== -1) {
    ret = 'opera'
  } else {
    ret = 'unknown'
  }
  return ret
}

/** 配送不可能地域 */
export const checkDeliImposible = function (postcd) {
  if (!postcd) return true
  let top3code = postcd.substring(0, 3)
  if (top3code === '001' || top3code === '002' || top3code === '003' || top3code === '004' || top3code === '005' ||
    top3code === '006' || top3code === '007' || top3code === '040' || top3code === '041' || top3code === '042' ||
    top3code === '043' || top3code === '044' || top3code === '045' || top3code === '046' || top3code === '047' ||
    top3code === '048' || top3code === '049' || top3code === '050' || top3code === '051' || top3code === '052' ||
    top3code === '053' || top3code === '054' || top3code === '055' || top3code === '056' || top3code === '057' ||
    top3code === '058' || top3code === '059' || top3code === '060' || top3code === '061' || top3code === '062' ||
    top3code === '063' || top3code === '064' || top3code === '065' || top3code === '066' || top3code === '067' ||
    top3code === '068' || top3code === '069' || top3code === '070' || top3code === '071' || top3code === '072' ||
    top3code === '073' || top3code === '074' || top3code === '075' || top3code === '076' || top3code === '077' ||
    top3code === '078' || top3code === '079' || top3code === '080' || top3code === '081' || top3code === '082' ||
    top3code === '083' || top3code === '084' || top3code === '085' || top3code === '086' || top3code === '087' ||
    top3code === '088' || top3code === '089' || top3code === '090' || top3code === '091' || top3code === '092' ||
    top3code === '093' || top3code === '094' || top3code === '095' || top3code === '096' || top3code === '097' ||
    top3code === '098' || top3code === '099' || top3code === '519' || top3code === '685' || top3code === '781' ||
    top3code === '787' || top3code === '788' || top3code === '789' || top3code === '790' || top3code === '791' ||
    top3code === '794' || top3code === '795' || top3code === '797' || top3code === '798' || top3code === '799' ||
    top3code === '817' || top3code === '853' || top3code === '863' || top3code === '866' || top3code === '867' ||
    top3code === '876' || top3code === '878' || top3code === '879' || top3code === '894' || top3code === '900' ||
    top3code === '901' || top3code === '902' || top3code === '903' || top3code === '904' || top3code === '905' ||
    top3code === '906' || top3code === '907' || top3code === '952'
  ) {
    return false
  }

  if (postcd === '1000100' || postcd === '1000101' || postcd === '1000102' || postcd === '1000103' || postcd === '1000104' ||
    postcd === '1000211' || postcd === '1000212' || postcd === '1000301' || postcd === '1000400' || postcd === '1000401' ||
    postcd === '1000402' || postcd === '1000511' || postcd === '1000601' || postcd === '1001100' || postcd === '1001101' ||
    postcd === '1001102' || postcd === '1001103' || postcd === '1001211' || postcd === '1001212' || postcd === '1001213' ||
    postcd === '1001301' || postcd === '1001400' || postcd === '1001401' || postcd === '1001511' || postcd === '1001621' ||
    postcd === '1001622' || postcd === '1001623' || postcd === '1001701' || postcd === '1002100' || postcd === '1002101' ||
    postcd === '1002211' || postcd === '1007001' || postcd === '1007002' || postcd === '1007003' || postcd === '1007004' ||
    postcd === '1007005' || postcd === '1007006' || postcd === '1007007' || postcd === '1007008' || postcd === '1007009' ||
    postcd === '1007010' || postcd === '1007011' || postcd === '1007012' || postcd === '1007013' || postcd === '1007014' ||
    postcd === '1007015' || postcd === '1007016' || postcd === '1007017' || postcd === '1007018' || postcd === '1007019' ||
    postcd === '1007020' || postcd === '1007021' || postcd === '1007022' || postcd === '1007023' || postcd === '1007024' ||
    postcd === '1007025' || postcd === '1007026' || postcd === '1007027' || postcd === '1007028' || postcd === '1007029' ||
    postcd === '1007030' || postcd === '1007031' || postcd === '1007032' || postcd === '1007033' || postcd === '1007034' ||
    postcd === '1007035' || postcd === '1007036' || postcd === '1007037' || postcd === '1007038' || postcd === '1007090' ||
    postcd === '6471322' || postcd === '6471323' || postcd === '6471324' || postcd === '6471325' || postcd === '6840100' ||
    postcd === '6840101' || postcd === '6840102' || postcd === '6840103' || postcd === '6840104' || postcd === '6840105' ||
    postcd === '6840106' || postcd === '6840107' || postcd === '6840211' || postcd === '6840300' || postcd === '6840301' ||
    postcd === '6840302' || postcd === '6840303' || postcd === '6840400' || postcd === '6840401' || postcd === '6840402' ||
    postcd === '6840403' || postcd === '6840404' || postcd === '6840411' || postcd === '6840412' || postcd === '6840413' ||
    postcd === '7250200' || postcd === '7250231' || postcd === '7250301' || postcd === '7250302' || postcd === '7250303' ||
    postcd === '7250401' || postcd === '7250402' || postcd === '7250403' || postcd === '7390040' || postcd === '7390049' ||
    postcd === '7390600' || postcd === '7390601' || postcd === '7390602' || postcd === '7390603' || postcd === '7390604' ||
    postcd === '7390605' || postcd === '7390606' || postcd === '7390607' || postcd === '7390611' || postcd === '7390612' ||
    postcd === '7390613' || postcd === '7390614' || postcd === '7390615' || postcd === '7390616' || postcd === '7390621' ||
    postcd === '7390622' || postcd === '7390623' || postcd === '7390624' || postcd === '7390625' || postcd === '7390626' ||
    postcd === '7390627' || postcd === '7390628' || postcd === '7390631' || postcd === '7390632' || postcd === '7390633' ||
    postcd === '7390634' || postcd === '7390635' || postcd === '7390636' || postcd === '7390637' || postcd === '7390641' ||
    postcd === '7390642' || postcd === '7390643' || postcd === '7390644' || postcd === '7390645' || postcd === '7390646' ||
    postcd === '7390651' || postcd === '7390652' || postcd === '7390653' || postcd === '7390654' || postcd === '7390655' ||
    postcd === '7390656' || postcd === '7390657' || postcd === '7392211' || postcd === '7392627' || postcd === '7392628' ||
    postcd === '7392629' || postcd === '7613110' || postcd === '7614100' || postcd === '7614101' || postcd === '7614102' ||
    postcd === '7614103' || postcd === '7614104' || postcd === '7614105' || postcd === '7614106' || postcd === '7614111' ||
    postcd === '7614112' || postcd === '7614113' || postcd === '7614114' || postcd === '7614115' || postcd === '7614121' ||
    postcd === '7614122' || postcd === '7614131' || postcd === '7614132' || postcd === '7614133' || postcd === '7614134' ||
    postcd === '7614141' || postcd === '7614142' || postcd === '7614143' || postcd === '7614144' || postcd === '7614145' ||
    postcd === '7614146' || postcd === '7614151' || postcd === '7614152' || postcd === '7614153' || postcd === '7614154' ||
    postcd === '7614155' || postcd === '7614300' || postcd === '7614301' || postcd === '7614302' || postcd === '7614303' ||
    postcd === '7614304' || postcd === '7614305' || postcd === '7614306' || postcd === '7614307' || postcd === '7614308' ||
    postcd === '7614401' || postcd === '7614402' || postcd === '7614403' || postcd === '7614404' || postcd === '7614405' ||
    postcd === '7614411' || postcd === '7614412' || postcd === '7614421' || postcd === '7614422' || postcd === '7614423' ||
    postcd === '7614424' || postcd === '7614425' || postcd === '7614426' || postcd === '7614431' || postcd === '7614432' ||
    postcd === '7614433' || postcd === '7614434' || postcd === '7614661' || postcd === '7614662' || postcd === '7614663' ||
    postcd === '7614664' || postcd === '8110123' || postcd === '8110124' || postcd === '8110125' || postcd === '8112128' ||
    postcd === '8112129' || postcd === '8112315' || postcd === '8112316' || postcd === '8112317' || postcd === '8112318' ||
    postcd === '8112319' || postcd === '8112417' || postcd === '8112418' || postcd === '8113119' || postcd === '8113209' ||
    postcd === '8115100' || postcd === '8115101' || postcd === '8115102' || postcd === '8115103' || postcd === '8115104' ||
    postcd === '8115105' || postcd === '8115106' || postcd === '8115107' || postcd === '8115111' || postcd === '8115112' ||
    postcd === '8115113' || postcd === '8115114' || postcd === '8115115' || postcd === '8115116' || postcd === '8115117' ||
    postcd === '8115121' || postcd === '8115122' || postcd === '8115123' || postcd === '8115124' || postcd === '8115125' ||
    postcd === '8115131' || postcd === '8115132' || postcd === '8115133' || postcd === '8115134' || postcd === '8115135' ||
    postcd === '8115136' || postcd === '8115141' || postcd === '8115142' || postcd === '8115143' || postcd === '8115144' ||
    postcd === '8115151' || postcd === '8115152' || postcd === '8115153' || postcd === '8115154' || postcd === '8115155' ||
    postcd === '8115161' || postcd === '8115162' || postcd === '8115163' || postcd === '8115201' || postcd === '8115202' ||
    postcd === '8115203' || postcd === '8115204' || postcd === '8115211' || postcd === '8115212' || postcd === '8115213' ||
    postcd === '8115214' || postcd === '8115215' || postcd === '8115221' || postcd === '8115222' || postcd === '8115223' ||
    postcd === '8115224' || postcd === '8115225' || postcd === '8115226' || postcd === '8115301' || postcd === '8115311' ||
    postcd === '8115312' || postcd === '8115313' || postcd === '8115314' || postcd === '8115315' || postcd === '8115316' ||
    postcd === '8115321' || postcd === '8115322' || postcd === '8115323' || postcd === '8115324' || postcd === '8115325' ||
    postcd === '8115326' || postcd === '8115461' || postcd === '8115462' || postcd === '8115463' || postcd === '8115464' ||
    postcd === '8115465' || postcd === '8115466' || postcd === '8115467' || postcd === '8115468' || postcd === '8115501' ||
    postcd === '8115511' || postcd === '8115512' || postcd === '8115513' || postcd === '8115521' || postcd === '8115522' ||
    postcd === '8115523' || postcd === '8115531' || postcd === '8115532' || postcd === '8115533' || postcd === '8115541' ||
    postcd === '8115542' || postcd === '8115543' || postcd === '8115544' || postcd === '8115545' || postcd === '8115546' ||
    postcd === '8115551' || postcd === '8115552' || postcd === '8115553' || postcd === '8115554' || postcd === '8115555' ||
    postcd === '8115556' || postcd === '8115731' || postcd === '8115732' || postcd === '8115733' || postcd === '8115734' ||
    postcd === '8115741' || postcd === '8115742' || postcd === '8115743' || postcd === '8115744' || postcd === '8115751' ||
    postcd === '8115752' || postcd === '8115753' || postcd === '8115754' || postcd === '8115755' || postcd === '8115756' ||
    postcd === '8115757' || postcd === '8570300' || postcd === '8570311' || postcd === '8570312' || postcd === '8570313' ||
    postcd === '8570314' || postcd === '8570315' || postcd === '8570321' || postcd === '8570322' || postcd === '8570323' ||
    postcd === '8570324' || postcd === '8570331' || postcd === '8570332' || postcd === '8570333' || postcd === '8570334' ||
    postcd === '8570335' || postcd === '8570336' || postcd === '8570337' || postcd === '8570338' || postcd === '8570341' ||
    postcd === '8570342' || postcd === '8570343' || postcd === '8570344' || postcd === '8570351' || postcd === '8570352' ||
    postcd === '8570353' || postcd === '8570361' || postcd === '8574101' || postcd === '8574102' || postcd === '8574103' ||
    postcd === '8574211' || postcd === '8574212' || postcd === '8574213' || postcd === '8574214' || postcd === '8574400' ||
    postcd === '8574401' || postcd === '8574402' || postcd === '8574404' || postcd === '8574405' || postcd === '8574411' ||
    postcd === '8574412' || postcd === '8574413' || postcd === '8574414' || postcd === '8574415' || postcd === '8574416' ||
    postcd === '8574511' || postcd === '8574512' || postcd === '8574513' || postcd === '8574514' || postcd === '8574601' ||
    postcd === '8574602' || postcd === '8574603' || postcd === '8574604' || postcd === '8574700' || postcd === '8574701' ||
    postcd === '8574702' || postcd === '8574703' || postcd === '8574704' || postcd === '8574705' || postcd === '8574706' ||
    postcd === '8574707' || postcd === '8574708' || postcd === '8574709' || postcd === '8574711' || postcd === '8574712' ||
    postcd === '9580061' || postcd === '9790622' || postcd === '9790622' || postcd === '9791100' || postcd === '9791101' ||
    postcd === '9791111' || postcd === '9791112' || postcd === '9791121' || postcd === '9791122' || postcd === '9791131' ||
    postcd === '9791132' || postcd === '9791141' || postcd === '9791151' || postcd === '9791152' || postcd === '9791161' ||
    postcd === '9791162' || postcd === '9791171' || postcd === '9791300' || postcd === '9791301' || postcd === '9791302' ||
    postcd === '9791303' || postcd === '9791304' || postcd === '9791305' || postcd === '9791306' || postcd === '9791307' ||
    postcd === '9791308' || postcd === '9791400' || postcd === '9791401' || postcd === '9791402' || postcd === '9791411' ||
    postcd === '9791412' || postcd === '9791421' || postcd === '9791422' || postcd === '9791423' || postcd === '9791431' ||
    postcd === '9791432' || postcd === '9791433' || postcd === '9791441' || postcd === '9791442' || postcd === '9791451' ||
    postcd === '9791452' || postcd === '9791453' || postcd === '9791461' || postcd === '9791462' || postcd === '9791463' ||
    postcd === '9791471' || postcd === '9791472' || postcd === '9791500' || postcd === '9791501' || postcd === '9791502' ||
    postcd === '9791503' || postcd === '9791504' || postcd === '9791505' || postcd === '9791506' || postcd === '9791511' ||
    postcd === '9791512' || postcd === '9791513' || postcd === '9791521' || postcd === '9791522' || postcd === '9791523' ||
    postcd === '9791524' || postcd === '9791525' || postcd === '9791526' || postcd === '9791531' || postcd === '9791532' ||
    postcd === '9791533' || postcd === '9791534' || postcd === '9791535' || postcd === '9791536' || postcd === '9791541' ||
    postcd === '9791542' || postcd === '9791543' || postcd === '9791544' || postcd === '9791545' || postcd === '9791706' ||
    postcd === '9791751' || postcd === '9791752' || postcd === '9791753' || postcd === '9791754' || postcd === '9791755' ||
    postcd === '9791756' || postcd === '9791757'
  ) {
    return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/main/js/utils/Check.js